import * as React from 'react'

import Box from '@mui/material/Box'
import Alert from '@mui/material/Alert'
import CircularProgress from '@mui/material/CircularProgress'

import { FormWrapper } from './FormWrapper'
import { useGetSalesTeamListOnMount } from '@user/store/salesTeam/hooks'
import { useGetAgreementSettingsOnMount } from '@user/store/dashboard/widgets/manageAgreements/hooks/useGetAgreementSettingsOnMount'

function ContentBack() {
  const teamStatus = useGetSalesTeamListOnMount()
  useGetAgreementSettingsOnMount()

  return (
    <>
      {teamStatus === 'pending' && (
        <Box p={2} display="flex" justifyContent="center">
          <CircularProgress />
        </Box>
      )}

      {teamStatus === 'fail' && <Alert>Failed to load widget settings.</Alert>}

      {teamStatus === 'success' && <FormWrapper />}
    </>
  )
}

ContentBack.displayName = 'ManageAgreementsContentBack'

export { ContentBack }
